import { Icon } from "@/components/icons/Icon";
import { ChalkLink } from "@/components/interactive/ChalkLink";
import { ReactNode } from "react";

export interface BreadCrumbProps {
  href?: string | URL;
  children: ReactNode;
  onClick?: () => void;
}

export function BreadCrumb({ href, children, onClick }: BreadCrumbProps) {
  const content = (
    <button
      className={
        "group/breadcrumb flex flex-row items-center cursor-pointer hover:text-cds-bright-green-300 text-zinc-500 text-xs w-fit"
      }
    >
      <BreadcrumbBackArrow />
      {children}
    </button>
  );
  return (
    <div className="block">
      {href ? (
        <ChalkLink href={href} onClick={onClick} className={"flex w-fit"} unstyled>
          {content}
        </ChalkLink>
      ) : (
        <button className={"text-left"} onClick={onClick}>
          {content}
        </button>
      )}
    </div>
  );
}

export const BreadcrumbBackArrow = () => (
  <Icon
    name={"arrowLeft"}
    size={"sm"}
    className="mr-1 -mt-0.5 text-zinc-500 group-hover/breadcrumb:text-cds-bright-green-300"
  />
);

export const BreadcrumbSeparator = () => <Icon name={"chevronRight"} size={"sm"} />;
